enum StageEventType {
  HAMSTER_SWARM = "HAMSTER_SWARM",
  SCORPION_SWARM = "SCORPION_SWARM",
  VULTURE_SWARM = "VULTURE_SWARM",
  CHICKEN_SWARM = "CHICKEN_SWARM",
  SPIDER_SWARM = "SPIDER_SWARM",
  BEE_SWARM = "BEE_SWARM",
  CAMEL_CARAVAN = "CAMEL_CARAVAN",
  // FAIRY_NPC = 'FAIRY_NPC',
  // VAMPRIE_NPC = 'VAMPRIE_NPC',
  // BUSINESSMAN_NPC = 'BUSINESSMAN_NPC'
}

export default StageEventType;
